import React from 'react';
import PropTypes from 'prop-types';
import Link from './shared/Link';
import utils from '../../../common/utils';
import fabric from '../../../common/fabric';

/**
 * Circle component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Circle = props => {
  const { hyperlink, params, matrixGroup, globalScale } = props;
  const { shadow } = params;
  const transformMatrix = matrixGroup
    ? fabric.util.multiplyTransformMatrices(
        matrixGroup,
        params.ludus.transformMatrix,
      )
    : params.ludus.transformMatrix;

  const object = new fabric.LudusCircle(params);

  object.set({
    shadow: null,
    ludus: { ...object.ludus, transformMatrix: transformMatrix },
  });

  const objectRendered = `<svg 
  fill="none" xmlns="http://www.w3.org/2000/svg">${object.toSVG()}</svg>`;

  const blockStyles = {
    ...props.style,
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    transform: `scale(${globalScale})`,
    mixBlendMode:
      props.params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : props.params.globalCompositeOperation,
    filter: shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(shadow, 0, 1, false)
      : 'none',
  };

  return (
    <Link
      hyperlink={hyperlink}
      style={blockStyles}
      dangerouslySetInnerHTML={{ __html: objectRendered }}
    />
  );
};
Circle.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number.isRequired,
};
Circle.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
};

export default Circle;
